// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

const TITLE = 'Lock';

interface LockProps {
  className?: string;
  title?: string;
}

export function Lock({ className, title }: LockProps) {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      aria-label={TITLE}
      role="img"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title || TITLE}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5 7C9.5 5.61929 10.6193 4.5 12 4.5C13.3807 4.5 14.5 5.61929 14.5 7V9H9.5V7ZM7 9V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V9H18C19.1046 9 20 9.89543 20 11V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V11C4 9.89543 4.89543 9 6 9H7Z"
        fill="currentColor"
      />
    </svg>
  );
}
